export var TRUE_LABEL = 'true';
export var FALSE_LABEL = 'false';
export var OPTIONS = [{
  label: TRUE_LABEL,
  value: true
}, {
  label: FALSE_LABEL,
  value: false
}];